import * as Yup from 'yup'
import i18next from '../../../../i18n/i18n'

export const AddPremiseUserSchema = Yup.object().shape({
    premise_id: Yup.string().required(i18next.t('premiseUser.error_premise')),
    role_id: Yup.array().min(1, i18next.t('premiseUser.error_role')).required(i18next.t('premiseUser.error_role')),
    joining_date: Yup.string().when('is_staff', {
        is: true,
        then: (schema) => schema.required(i18next.t('premiseUser.error_joining_date')),
        otherwise: (schema) => schema.nullable().notRequired(),
    }),
    salary: Yup.number()
        .when('is_staff', {
            is: true,
            then: (schema) => schema
                .typeError(i18next.t('premiseUser.error_salary'))
                .min(0, i18next.t('premiseUser.error_salary_negative'))
                .required(i18next.t('premiseUser.error_salary')),
            otherwise: (schema) => schema.nullable().notRequired(),
        }),
    fname: Yup.string().required(i18next.t('premiseUser.error_fname')),
    lname: Yup.string().required(i18next.t('premiseUser.error_lname')),
    gender: Yup.string().required(i18next.t('premiseUser.error_gender')),
    username: Yup.string().required(i18next.t('premiseUser.error_username')),
    password: Yup.string().required(i18next.t('premiseUser.error_password')),
    confirmPassword: Yup.string().oneOf([Yup.ref('password'), null], i18next.t('premiseUser.error_password_match')).required(i18next.t('premiseUser.error_confirm_password')),
    mobile: Yup.string().matches(/^[0-9]+$/, i18next.t('premiseUser.error_invalid_mobile')).required(i18next.t('premiseUser.error_mobile')),
    email: Yup.string().email(i18next.t('premiseUser.error_invalid_email')).required(i18next.t('premiseUser.error_email')),
    profile: Yup.mixed()
        .test('fileSize', i18next.t('user.error_file_size'), (value) => {
            if (!value) return true;
            return value.size <= 5242880; // 5MB
        })
        .test('fileType', i18next.t('user.error_file_type'), (value) => {
            if (!value) return true;
            return ['image/jpeg', 'image/jpg', 'image/png'].includes(value.type);
        }),
    dob: Yup.string().nullable().notRequired(i18next.t('premiseUser.error_dob')),
    status: Yup.string().required(i18next.t('premiseUser.error_status')),
})

export const UpdatePremiseUserSchema = Yup.object().shape({
    premise_id: Yup.string().required(i18next.t('premiseUser.error_premise')),
    role_id: Yup.array().min(1, i18next.t('premiseUser.error_role')).required(i18next.t('premiseUser.error_role')),
    joining_date: Yup.string().when('is_staff', {
        is: true,
        then: (schema) => schema.required(i18next.t('premiseUser.error_joining_date')),
        otherwise: (schema) => schema.nullable().notRequired(),
    }),
    salary: Yup.number()
        .when('is_staff', {
            is: true,
            then: (schema) => schema
                .typeError(i18next.t('premiseUser.error_salary'))
                .min(0, i18next.t('premiseUser.error_salary_negative'))
                .required(i18next.t('premiseUser.error_salary')),
            otherwise: (schema) => schema.nullable().notRequired(),
        }),
    fname: Yup.string().required(i18next.t('premiseUser.error_fname')),
    lname: Yup.string().required(i18next.t('premiseUser.error_lname')),
    gender: Yup.string().required(i18next.t('premiseUser.error_gender')),
    username: Yup.string().required(i18next.t('premiseUser.error_username')),
    password: Yup.string().notRequired(i18next.t('premiseUser.error_password')),
    mobile: Yup.string().matches(/^[0-9]+$/, i18next.t('premiseUser.error_invalid_mobile')).required(i18next.t('premiseUser.error_mobile')),
    email: Yup.string().email(i18next.t('premiseUser.error_invalid_email')).required(i18next.t('premiseUser.error_email')),
    profile: Yup.mixed()
        .test('fileSize', i18next.t('user.error_file_size'), (value) => {
            if (!value) return true;
            return value.size <= 5242880; // 5MB
        })
        .test('fileType', i18next.t('user.error_file_type'), (value) => {
            if (!value) return true;
            return ['image/jpeg', 'image/jpg', 'image/png'].includes(value.type);
        }),
    dob: Yup.string().nullable().notRequired(i18next.t('premiseUser.error_dob')),
    status: Yup.string().required(i18next.t('premiseUser.error_status')),
})